window.addEventListener("DOMContentLoaded", () => {
  const sections = document?.querySelectorAll(".testimonials-slider");
  sections?.forEach((item) => {
    const slidesWrapper = item?.querySelector(".section-wrapper");
    if (slidesWrapper) {
      const flkty = new Flickity(slidesWrapper, {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: "left",
      });
    }
  });
});
